import { useNavigate } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Card,
  Stack,
  Group,
  ThemeIcon,
} from '@mantine/core';
import { ArrowLeft, Search } from 'react-feather';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container size="sm" py={80}>
      <Card withBorder padding="xl" radius="lg">
        <Stack align="center" gap="lg">
          <ThemeIcon size={80} radius="xl" variant="light" color="gray">
            <Search size={40} />
          </ThemeIcon>

          <Title order={2} ta="center">
            Page Not Found
          </Title>

          <Text c="dimmed" ta="center" maw={400}>
            The page you're looking for doesn't exist or may have been moved.
          </Text>

          <Group mt="lg">
            <Button
              variant="light"
              leftSection={<ArrowLeft size={16} />}
              onClick={() => navigate('/')}
            >
              Go to Dashboard
            </Button>
          </Group>
        </Stack>
      </Card>
    </Container>
  );
}

export default NotFoundPage;
